import SettingProps from "../SettingProps";
import GenericSetting, {StyleSettingType} from "../genericsetting/GenericSetting";

export default function OutlineSetting(props: SettingProps) {
    return <GenericSetting {...props}
                           title={"Border"}
                           type={"border"}
                           targets={[
                                    { name: "Outline",target: 'outline' , type: StyleSettingType.text},
                                    { name: "Style", target: 'outline-style' , type: StyleSettingType.selections, options: [
                                            {label: "none", value: ""},
                                            {label: "hidden", value: "hidden"},
                                            {label: "dotted", value: "dotted"},
                                            {label: "dashed", value: "dashed"},
                                            {label: "solid", value: "solid"},
                                            {label: "double", value: "double"},
                                            {label: "groove", value: "groove"},
                                            {label: "ridge", value: "ridge"},
                                            {label: "inset", value: "inset"},
                                            {label: "outset", value: "outset"},
                                        ]},
                                    { name: "Top",target: 'outline-width' , type: StyleSettingType.default_size},
                                    { name: "Color", target: 'outline-color' , type: StyleSettingType.color},
                                ]}
    />
}